"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tokens = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("@CommonFrontendBackend/Hubspot/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Tokens = (function (_super) {
    __extends(Tokens, _super);
    function Tokens() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.renderObjectTypeSelector = function () {
            if (_this.props.objectType === Types_1.AssociatedObjectType.Company) {
                return;
            }
            else {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement("button", { className: (0, classnames_1.default)("tab-button", { unselected: _this.props.isCompanySelected }), onClick: _this.props.selectObjectToken }, _this.props.objectType),
                    react_1.default.createElement("button", { className: (0, classnames_1.default)("tab-button", { unselected: !_this.props.isCompanySelected }), onClick: _this.props.selectAssociatedCompany }, "Company")));
            }
        };
        _this.renderLoader = function () {
            return (react_1.default.createElement("div", { className: "loading" },
                react_1.default.createElement("div", { className: "text" }, "Loading fields"),
                react_1.default.createElement("div", { className: "loader" })));
        };
        _this.renderTokenTable = function () {
            var rows = _this.props.tokens.map(function (token) { return _this.renderTokenRow(token); });
            return (react_1.default.createElement("table", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "Token Name"),
                    react_1.default.createElement("th", null, "Token Value")),
                rows));
        };
        _this.renderTokenRow = function (token) {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null, token.name),
                react_1.default.createElement("td", null, token.value || "")));
        };
        return _this;
    }
    Tokens.prototype.render = function () {
        var _a = this.props, objectType = _a.objectType, isLoading = _a.isLoading;
        return (react_1.default.createElement("div", { className: "hubspot" },
            react_1.default.createElement("div", { className: "tokens" },
                react_1.default.createElement("div", { className: "container" },
                    react_1.default.createElement("div", { className: "header" },
                        "HubSpot ",
                        objectType,
                        " Tokens"),
                    react_1.default.createElement("div", { className: "desc" },
                        "Qwilr CRM Tokens automatically map existing data in your HubSpot record to Tokens in Qwilr. This means that you can automatically personalize your documents with information in your CRM like",
                        " ",
                        react_1.default.createElement("b", null, "Customer Name"),
                        " or ",
                        react_1.default.createElement("b", null, "Address"),
                        " without having to manually fill it in."),
                    react_1.default.createElement("div", { className: "desc" }, "You can find the available tokens by connecting your Template to HubSpot in Qwilr, and then choosing the T icon in the top right of the template editor. From here, you will see a list of available tokens in the HubSpot tab."),
                    react_1.default.createElement("img", { className: "image", src: "Assets/Images/integrations/hubspot-show-tokens-explainer.png" }),
                    react_1.default.createElement("div", { className: "desc" },
                        "Below is an example of the tokens for standard fields on this record. Note: it does not include custom fields, but these will be available to add to your template in Qwilr.",
                        " "),
                    react_1.default.createElement("div", { className: "desc" },
                        "If you do add",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://knowledge.hubspot.com/crm-setup/manage-your-properties" }, "custom fields"),
                        " to your HubSpot records, it can take up to 15 minutes for them to appear in the Qwilr token panel."),
                    react_1.default.createElement("div", { className: "subheader" },
                        "List of fields in ",
                        react_1.default.createElement("span", { className: "lowercase" }, objectType),
                        ":"),
                    this.renderObjectTypeSelector(),
                    isLoading ? this.renderLoader() : this.renderTokenTable(),
                    react_1.default.createElement("div", { className: "subheader" }, "Important Note"),
                    react_1.default.createElement("div", { className: "desc" },
                        "Any token that is pulling from a field that",
                        " ",
                        react_1.default.createElement("b", null, "is not filled in by HubSpot is automatically defaulted to be blank when you create a page"),
                        "."),
                    react_1.default.createElement("div", { className: "desc" },
                        "For more information please see our article on",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/347-hubspot-template-creation#variables" }, "Creating Templates and Adding Tokens"),
                        ", or reach out to a member of our team via ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "mailto:help@qwilr.com" }, "help@qwilr.com"))))));
    };
    Tokens.defaultProps = {
        tokens: [],
    };
    Tokens = __decorate([
        mobx_react_1.observer
    ], Tokens);
    return Tokens;
}(react_1.default.Component));
exports.Tokens = Tokens;
